import MainContainer from "./MainContainer";
import TitleTextSection from "./TitelTextSection";
import BandMiniDisplayBlock from "./BandBigDisplayBlock";
import ShowMoreLink from "./ShowMoreLink";

const ListBandsSection = ({ listName, underText, bands }) => {
  return (
    <>
      <MainContainer>
        <div>
          <div className="sm:py-4 flex justify-between items-center">
            <div>
              <TitleTextSection title={listName} subtitle={underText} />
            </div>
            <ShowMoreLink href="/discover" />
          </div>

          <div className="grid xl:grid-cols-3 grid-cols-1 grid-rows-auto gap-8">
            {bands.map((band, index) => (
              <div key={index}>
                <BandMiniDisplayBlock band={band} index={index} />
              </div>
            ))}
          </div>
        </div>
      </MainContainer>
    </>
  );
};
export default ListBandsSection;
